<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label" />
            <div class="dx-field-value">
                <dx-button text="Просмотр адреса по ЕГРЮЛ/ЕГРИП" @click="popupVisible = true" />
            </div>
        </div>
        <dx-popup
            :visible="popupVisible"
            :show-title="true"
            title="Адрес в ЕГРЮЛ"
            :drag-enabled="false"
            :hide-on-outside-click="true"
            :showCloseButton="true"
            @hidden="popupVisible = false"
        >
            <div class="flex flex-col h-full w-full px-2">
                <card-form
                    :meta="egrViewMeta"
                    :use-default-buttons="false"
                    :default-handlers="{ refresh: null, commit: null }"
                    :callbacks="{ refreshData: refreshData, saveData: null, isDirty: null }"
                />

            </div>

        </dx-popup>
    </div>
</template>

<script setup>
import { DxButton, DxPopup } from 'devextreme-vue';
import { ref } from 'vue';
import CardForm from '@/components/card-component/card-form.vue';
import egrViewMeta from '@/views/counteragents/counteragent-card/field-wrappers/egr-view-button-meta';

const props = defineProps({
    serverData: {
        type: Object,
        default: () => {},
    },
});

const popupVisible = ref(false);

const refreshData = async () => {
    console.log('egr-view refreshData ', props.serverData)
    return {
        result: true,
        data: props.serverData,
    };
};
</script>

<style>
.egr-view-content {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    padding: 5px 5px 0 5px;
}

.egr-view-adm {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-basis: 50%;
    padding: 5px 5px 0 5px;
}

.egr-view-mun {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-basis: 50%;
    padding: 5px 5px 0 5px;
}

.egr-dx-field {
    display: flex;
    flex-direction: column;
}

.egr-dx-field-label {
    display: flex;
    flex-grow: 1;
    align-self: start;
    font-size: 0.9rem;
    min-height: 1rem;
    width: 100%;
}

.egr-dx-field-value {
    width: 100%;
}

.egr-dx-field2-value {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.egr-dx-short-field-value {
    flex-basis: 50%;
    padding-right: 10px;
}


</style>
